export default {
  RECEIVE_SEARCH_RESULTS: 'RECEIVE_SEARCH_RESULTS'
};
